/**
 * Web cannot register Expo push tokens in the static export, so registration
 * is intentionally a no-op here (native uses push-registration.native.ts).
 */
export async function registerDevicePushToken(_input: {
  userId: string;
  timezone?: string | null;
}) {
  return null;
}

export function usePushRegistration() {
  // No-op on web.
}
